import React from 'react';
import { BookOpenCheck, ClipboardList, Layers, Users, User } from 'lucide-react';
import { useAuth } from '../context/AuthContext';
import { buildRoleWorkspaceNavItems } from '../config/roleWorkspaceConfig';
import RoleLayoutShell from './RoleLayoutShell';

const AccountantLayout = () => {
  const auth = useAuth();
  const navItems = buildRoleWorkspaceNavItems('accountant', auth).map((item) => ({
    ...item,
    Icon: item.to === '/profile' ? User : item.to.includes('transactions') && item.to === '/accountant' ? BookOpenCheck : item.to.includes('transactions') ? ClipboardList : item.to.includes('categories') ? Layers : Users,
    anyPermissions: item.permission,
  }));

  return <RoleLayoutShell title="EMS" subtitle="Accountant Workspace" navItems={navItems} />;
};

export default AccountantLayout;
